import axios from "axios";
import { baseUrl } from "../utils/constants";

export const downloadCsv = async (userToken, params) => {
  return new Promise(async (resolve, reject) => {
    const url = `${baseUrl}/contractor/download-csv-files?type=${params}`
    try {
      let response = await axios.get(url, {
        headers: {
          Authorization: userToken,
        },
        responseType: 'blob'
      })
      resolve(response.data)
    } catch (error) {
      console.log("api error::", error.response?.data);
      reject(error.response?.data)
    }
  })
}
